<template>
  <div class="row">
    <SwappingSquaresSpinner v-if="this.$store.getters.isLoading"
      :animation-duration="1000"
      :size="90"
      :color="this.$store.getters.config.palette.primary"
      style="margin: auto; position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);"
    />

    <div v-if="!this.$store.getters.isLoading" class="flex xs12">
      <va-card :title="$t('appSettings.appSettings')">
      </va-card>
    </div>

    <div v-if="!this.$store.getters.isLoading" class="flex xs12">
      <va-card stripe="primary">
        <form @submit.prevent="onsubmit()">
          <div class="row">
            <va-input
              v-model="appSettings.name"
              type="text"
              :label="$t('appSettings.appName')"
              :error="!!nameErrors.length"
              :error-messages="nameErrors"
              class="flex xs12 sm12 md12 lg12 xl12"
            />
          </div>
          <div class="row">
            <div class="flex xs6">
              <va-select
                :label="$t('appSettings.timezone')"
                v-model="appSettings.timezone"
                textBy="zoneName"
                keyBy="timezoneId"
                searchable
                :options="timezones"
                :error="!!timezoneError.length"
                :error-messages="timezoneError"
              />
            </div>
            <div class="flex xs6">
              <va-select
                :label="$t('appSettings.currency')"
                v-model="appSettings.currency"
                :options="currencies"
                textBy="description"
                keyBy="appCurrencyId"
                :error="!!currencyErrors.length"
                :error-messages="currencyErrors"
              />
            </div>
          </div>
          <div class="row">
            <div class="flex xs12 md6">
              <div class="flex md1">
                <va-color-square :value="appSettings.color"/>
              </div>
              <div class="flex md4">
                {{ $t('appSettings.adminWebAppColor') }}
              </div>
              <div>
                <va-advanced-color-picker
                  v-model="appSettings.color"
                  :error="!!colorErrors.length"
                  :error-messages="colorErrors"
                />
              </div>
            </div>
            <div class="flex xs12 md6">
              <div class="flex md1">
                <va-color-square :value="appSettings.colorClient"/>
              </div>
              <div class="flex md4">
                {{ $t('appSettings.clientWebAppColor') }}
              </div>
              <div>
                <va-advanced-color-picker
                  v-model="appSettings.colorClient"
                  :error="!!colorErrors.length"
                  :error-messages="colorErrors"
                />
              </div>
            </div>
          </div>
          <div class="row imgSelector">
            <img v-if="appSettings.logo" :src="appSettings.logo" class="flex xs1 sm1 md1 lg1 xl1"/>
            <div class="flex xs11 sm11 md11 lg11 xl11">
              <va-card :title="$t('appSettings.logo')">
                <div
                  class="va-file-upload"
                  :style="computedStyle"
                >
                  <div class="va-file-upload__field">
                    <va-button
                      class="va-file-upload__field__button"
                      :color="colorComputed"
                    >
                      {{ $t('appSettings.uploadFile') }}
                    </va-button>
                    <input
                      type="file"
                      class="va-file-upload__field__input"
                      ref="logo"
                      :accept="fileTypes"
                      @change="changeFieldValue"
                    >
                  </div>
                  <va-file-upload-list
                    v-if="files.length"
                    type="single"
                    :files="files"
                    :color="colorComputed"
                    @remove-single="removeSingleFile"
                  />
                  <va-modal
                    v-model="modal"
                    hideDefaultActions
                    :title="$t('appSettings.fileValidation')"
                    :message="$t('appSettings.incorrectFileType')"
                  />
                </div>
              </va-card>
            </div>
          </div>
          <div class="medium-editor">
            <div class="row">
              <div class="flex md12">
                <va-card :title="$t('appSettings.welcome')">
                  <div class="d-flex flex-center">
                    <va-medium-editor
                      @initialized="handleEditorInitialization"
                      :editor-options="editorOptions"
                      v-model="appSettings.welcomeMessage"
                      v-html="appSettings.welcomeMessage"
                    >
                    </va-medium-editor>
                  </div>
                </va-card>
              </div>
            </div>
          </div>
          <!--          <div class="row">-->
          <!--            <div class="flex xs12">-->
          <!--              <va-toggle-->
          <!--                v-model="toggleSelected"-->
          <!--                :label="$t('appSettings.enableAudioAlarm')"-->
          <!--              />-->
          <!--            </div>-->
          <!--          </div>-->
          <div class="row">
            <div class="flex xs12">
              <va-button :color="isNotificationToken ? 'success' : 'info'" @click="getMessagingToken" :disabled="!isNotificationToken">
                {{isNotificationToken ? $t('appSettings.enableNotifications') : $t('appSettings.notificationsEnabled')}}
              </va-button>
            </div>
          </div>
          <div class="d-flex justify--center mt-3">
            <va-button type="submit" class="my-0">{{ $t('appSettings.updateSettings') }}</va-button>
          </div>
        </form>
      </va-card>
    </div>
  </div>
</template>

<script>
import { SwappingSquaresSpinner } from 'epic-spinners'
import firebase from '@/configFirebase.js'
import axios from 'axios'
import errorHandlerMixin from '@/mixin/errorHandlerMixin'
import { getFocusColor } from 'vuestic-ui/src/services/color-functions'
import { ColorThemeMixin } from 'vuestic-ui/src/services/ColorThemePlugin'
import VaFileUploadList from 'vuestic-ui/src/components/vuestic-components/va-file-upload/VaFileUploadList.vue'

const { messaging } = firebase
export default {
  components: { SwappingSquaresSpinner, VaFileUploadList },
  mixins: [errorHandlerMixin, ColorThemeMixin],
  name: 'AppSettings',
  data () {
    return {
      appSettings: {
        color: '',
        name: '',
        logo: '',
        colorClient: '',
        timezone: {},
        currency: {},
      },
      editorOptions: {
        buttonLabels: 'fontawesome',
        autoLink: true,
        toolbar: {
          buttons: [
            'bold',
            'italic',
            'underline',
            'anchor',
            'h1',
            'h2',
            'h3',
            'html',
            'image',
            'orderedList',
            'unorderedlist',
          ],
        },
      },
      timezones: [],
      uploadRequest: null,
      image: [],
      currencies: [],
      timezoneError: [],
      colorErrors: [],
      nameErrors: [],
      imageErrors: [],
      currencyErrors: [],
      single: [],
      modal: false,
      files: [],
      fileTypes: '.png, .jpg, .jpeg, .gif',
      // toggleSelected: false,
    }
  },
  methods: {
    readFileAsync (file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()

        reader.onload = () => {
          resolve(reader.result)
        }
        reader.onerror = reject
        reader.readAsDataURL(file)
      })
    },
    async processFile () {
      const file = this.files[0]
      const arrayBuffer = await this.readFileAsync(file)

      if (arrayBuffer === null) {
        return
      }
      this.isSelectedFile = true
      this.uploadRequest = {
        data: arrayBuffer,
        duration: 0,
        type: file.type,
        size: file.size,
        title: file.name,
        clientIdentifier: '',
      }
    },
    onsubmit () {
      this.colorErrors = this.appSettings.color ? [] : [this.$t('appSettings.validation.requiredCountry')]
      this.nameErrors = this.appSettings.name ? [] : [this.$t('appSettings.validation.requiredName')]
      this.imageErrors = this.uploadRequest || this.appSettings.logo ? [] : [this.$t('appSettings.validation.requiredImage')]
      this.timezoneError = this.appSettings.timezone ? [] : [this.$t('appSettings.validation.requiredTimezone')]
      this.currencyErrors = this.appSettings.currency ? [] : [this.$t('appSettings.validation.requiredCurrency')]
      if (!this.appSettingsReady) {
        return
      }
      let welcomeMessage = this.editor.origElements.innerHTML
      if (welcomeMessage === '<p><br></p>') {
        welcomeMessage = ''
      }
      this.$store.commit('setLoading', true)
      this.$store.dispatch('postAppSettings', {
        color: this.appSettings.color,
        colorClient: this.appSettings.colorClient,
        name: this.appSettings.name,
        logo: this.appSettings.logo,
        timezoneId: this.appSettings.timezone.timezoneId,
        appCurrencyId: this.appSettings.currency.appCurrencyId,
        uploadRequest: this.uploadRequest,
        welcomeMessage: welcomeMessage,
      }).then(() => {
        this.initAppSettings()
        this.removeSingleFile()
      }).catch(err => this.errorHandler(err.response))
    },
    async initAppSettings () {
      this.timezones.splice(0, this.timezones.length, ...this.$store.getters.timezones)
      const appSettings = this.$store.getters.appSettings
      const currentTimezone = this.timezones.filter(function (item) {
        return item.timezoneId === appSettings.timezoneId
      })
      const currency = this.currencies.filter(function (item) {
        return item.appCurrencyId === appSettings.appCurrencyId
      })
      this.appSettings.color = appSettings.color
      this.appSettings.name = appSettings.name
      this.appSettings.logo = appSettings.logo
      this.appSettings.colorClient = appSettings.colorClient
      this.appSettings.timezone = currentTimezone[0]
      this.appSettings.currency = currency[0]
      this.appSettings.welcomeMessage = appSettings.welcomeMessage
      this.$store.commit('setLoading', false)
    },
    async initCurrencies (currencies) {
      this.currencies.splice(0, this.currencies.length, ...currencies)
    },
    getMessagingToken () {
      messaging.getToken().then(async (token) => {
        if (token) {
          const currentMessageToken = window.localStorage.getItem('messagingToken')
          if (currentMessageToken !== token) {
            await this.saveToken(token)
          }
        } else {
          this.notificationsPermisionRequest()
        }
        // eslint-disable-next-line handle-callback-err
      }).catch((err) => {})
    },
    notificationsPermisionRequest () {
      messaging.requestPermission()
        .then(() => {
          this.getMessagingToken()
        })
        // eslint-disable-next-line handle-callback-err
        .catch((err) => {})
    },
    listenTokenRefresh () {
      const currentMessageToken = window.localStorage.getItem('messagingToken')
      if (currentMessageToken) {
        messaging.onTokenRefresh(function () {
          messaging.getToken().then(function (token) {
            this.saveToken(token)
            // eslint-disable-next-line handle-callback-err
          }).catch((err) => {
          })
        })
      }
    },
    saveToken (token) {
      axios.post('https://us-central1-upio-user-app-1579104974406.cloudfunctions.net/GeneralSubscription', { token, namespace: 'dashboard' + this.$store.getters.namespace })
        .then(response => {
          window.localStorage.setItem('messagingToken', token)
          // eslint-disable-next-line handle-callback-err
        }).catch((err) => {
        })
    },
    changeFieldValue (e) {
      this.uploadFile(e)
      this.$refs.logo.value = ''
    },
    uploadFile (e) {
      let files = e.target.files || e.dataTransfer.files
      // type validation
      if (this.fileTypes) {
        files = this.validateFiles(files)
      }
      this.files = [...this.files, ...files]
      this.processFile()
    },
    removeSingleFile () {
      this.files = []
    },
    validateFiles (files) {
      const fileArray = Object.values(files)
      return fileArray.filter((file) => {
        const fileName = file.name || file.url
        if (!fileName) {
          return false
        } else {
          if (file.url) {
            return true
          } else {
            const extension = fileName.substring(fileName.lastIndexOf('.') + 1).toLowerCase()
            const correctExt = this.fileTypes.includes(extension)
            if (!correctExt) {
              this.modal = true
            }
            return correctExt
          }
        }
      })
    },
    handleEditorInitialization (editor) {
      this.editor = editor
    },
  },
  computed: {
    isNotificationToken () {
      return window.localStorage.getItem('messagingToken')
    },
    appSettingsReady () {
      return !(this.nameErrors.length || this.colorErrors.length || this.imageErrors.length || this.timezoneError.length)
    },
    computedStyle () {
      return {
        backgroundColor: this.dropzone ? getFocusColor(this.colorComputed) : 'transparent',
      }
    },
  },
  mounted () {
    this.listenTokenRefresh()
    this.$store.commit('setLoading', true)
    this.$store.dispatch('getAppSettings')
      .then(() => this.$store.dispatch('timezones'))
      .then(() => this.$store.dispatch('getAppCurrency'))
      .then((resp) => this.initCurrencies(resp.data.message))
      .then(() => this.initAppSettings())
      .catch((err) => {
        this.errorHandler(err.response)
      })
    this.files = this.validateFiles(this.files)
  },
}
</script>

<style>
  .imgSelector {
    margin: 25px auto !important;
    border: 1px solid;
    border-radius: 3px;
    background-color: #e8ecec;
  }

  .imgSelector img {
    width: auto;
    height: max-content;
    align-self: center;
    padding: 0.25rem !important;
  }

  @media screen and (max-width: 767px) {
    .medium-editor iframe {
      width: 100%;
    }

    .medium-editor .va-card__body {
      padding: inherit;
    }
  }
</style>
